import { render, staticRenderFns } from "./TaskCardsView.component.vue?vue&type=template&id=335b62c0&scoped=true&"
import script from "./TaskCardsView.component.vue?vue&type=script&lang=js&"
export * from "./TaskCardsView.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskCardsView.component.vue?vue&type=style&index=0&id=335b62c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b62c0",
  null
  
)

export default component.exports